import { formatCurrency as i, formatDate as c, formatPercentage as f } from "../../../utils/helpers.formatting.js";
const o = ({
  currencyCode: n = "$",
  format: e,
  row: t,
  value: r
}) => e ? typeof e == "function" ? e(r, t) : e === "currency" ? i(r, n) : e === "number" ? typeof r == "number" ? r : Number(r) : e === "date" ? c(r) : e === "percent" ? f(r) : r : r;
export {
  o as IressTableFormattedValue
};
